export function addRoutePath({ title, path,  }) {
    const other = JSON.parse(sessionStorage.getItem('navList') || '[]')
    other.push({
        meta: {
            title
        },
        path,
        redirect: path
    })
    sessionStorage.setItem('navList', JSON.stringify(other))
}

export function clearRoutePath() {
    sessionStorage.setItem('navList', '[]')
}

export function deleteRoute(path) {
    if (!path) {
        return
    }
    let other = JSON.parse(sessionStorage.getItem('navList') || '[]')
    let idx = 0
    other.forEach((element, idx1) => {
        if (element.path == path) {
            idx = idx1
        }
    });
    if (idx > 0) {
        other = other.slice(0, idx)
    } else {
        other = []
    }
    sessionStorage.setItem('navList', JSON.stringify(other))
}